import { render } from "./App.vue?vue&type=template&id=595d85f0"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=595d85f0&lang=css"

import exportComponent from "/Users/elenejikia/Desktop/Parsons/Studio2/major-studio-2-sp24-1/06-vue-scrollytelling/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__